<script>
import baseMixin from '@/mixins/baseMixin'
import EmptyStateBlock from './empty-state-block.vue'

export default {
  name: 'EmptySearchResultsBlock',
  components: { EmptyStateBlock },
  mixins: [baseMixin],
  props: {
    search: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <EmptyStateBlock
    :title="$t('general.orgFilter.dialog.search.emptyState.title', [search])"
    :description="$t('general.orgFilter.dialog.search.emptyState.description')"
  >
    <template v-slot:button>
      <v-btn text outlined @click="$emit('clear')">
        <v-icon left>mdi-close</v-icon>
        {{ $t('general.orgFilter.dialog.search.emptyState.clearBtn') }}
      </v-btn>
    </template>
  </EmptyStateBlock>
</template>
